import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m7,15h10v3h2V4c0-1.098.894-1.996,1.992-2l1.027-.004-.009-2-1.026.004c-2.197.009-3.983,1.804-3.983,4v3H7v-3c0-1.098.894-1.996,1.992-2l1.027-.004-.009-2-1.026.004c-2.197.009-3.983,1.804-3.983,4v14h2v-3Zm10-6v4H7v-4h10Zm7.009,13.632c-.76.869-1.856,1.368-3.009,1.368-1.194,0-2.266-.526-3-1.357-.734.832-1.806,1.357-3,1.357s-2.266-.526-3-1.357c-.734.832-1.806,1.357-3,1.357s-2.266-.526-3-1.357c-.734.832-1.806,1.357-3,1.357-1.152,0-2.249-.499-3.009-1.368l1.506-1.316c.38.435.928.684,1.503.684,1.103,0,2-.897,2-2h2c0,1.103.897,2,2,2s2-.897,2-2h2c0,1.103.897,2,2,2s2-.897,2-2h2c0,1.103.897,2,2,2,.575,0,1.123-.25,1.503-.684l1.506,1.316Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/pool-icon.jsx